module.exports = "/_next/static/images/lp-1bg-9d623be1ff0e8e4b76db30152b9c9ae9.png";